import _ from "lodash";
import {
  isNullOrWhiteSpace,
  ifNullOrWhiteSpace,
  isEqual,
} from "./JarvisCommonService";
import { getLanguage } from "./JarvisLocalStorageService";

let JarvisBaseSettings = null;

export async function preloadJarvisBaseSettings() {
  if (JarvisBaseSettings) return;
  const response = await fetch("/JarvisBaseSettings.json");
  if (!response.ok) throw new Error("Failed to load config");
  JarvisBaseSettings = await response.json();
}

export function getJarvisBaseSettings() {
  if (!JarvisBaseSettings) throw new Error("JarvisBaseSettings not loaded yet");
  return JarvisBaseSettings;
}

export default class JarvisBaseSettingsService {
  static getService() {
    return this;
  }

  static getEnvironment() {
    const c = getJarvisBaseSettings();
    return ifNullOrWhiteSpace(c.Environment, "Dev");
  }
  static getViews(){
    const c = getJarvisBaseSettings();
    return c.views??[{name:"View 2",componentName:"view2"}]
  }

  static getJarvisUIXUrl() {
    const c = getJarvisBaseSettings();
    return ifNullOrWhiteSpace(
      _.get(c, "jarvis-uix-url"),
      "http://localhost:3001"
    );
  }

  static getApiEndPoint(systemKey) {
    const c = getJarvisBaseSettings();
    let environment = c.Environment;
    if (!environment) environment = "DEV";
    const system = c.Systems.find((item) => {
      return item.Key.toLowerCase() === systemKey.toLowerCase();
    });
    if (!system) return null;
    const api = system.Api.find((item) => {
      return item.Environment.toLowerCase() === environment.toLowerCase();
    });
    let endpoint = ifNullOrWhiteSpace(api.EndPoint, window.location.origin);
    if (!endpoint.endsWith("/")) endpoint += "/";
    return endpoint;
  }

  static getCustomApiEndpoint(apiKey) {
    const jarvisApiSetting = require("JarvisCustom/JarvisApiSettings.json");
    const c = getJarvisBaseSettings();
    let environment = c.Environment;
    if (!environment) environment = "DEV";
    const find = jarvisApiSetting.Apis.find((item) => {
      return item.Key.toLowerCase() === apiKey.toLowerCase();
    });

    if (!find) return null;
    const api = find.Api.find((item) => {
      return item.Environment.toLowerCase() === environment.toLowerCase();
    });
    let endpoint = ifNullOrWhiteSpace(api.EndPoint, window.location.origin);
    if (!endpoint.endsWith("/")) endpoint += "/";
    return endpoint;
  }
}

export const jarvisComponentMustBeExcluded = (componentName) => {
  const jarvisCustomSetting = require("JarvisCustom/JarvisCustomSettings.json");
  const find = jarvisCustomSetting.components.find(
    (x) => isEqual(x.name, componentName) && x.mustBeExcluded === true
  );
  if (find) return true;
  return false;
};

export const jarvisCustomServiceMustBeReplaced = (serviceName) => {
  const jarvisCustomSetting = require("JarvisCustom/JarvisCustomSettings.json");
  const find = jarvisCustomSetting.customServices.find((x) =>
    isEqual(x.name, serviceName)
  );
  let result = _.pick(find, ["mustBeReplaced", "apiKey", "url"]);
  result.mustBeReplaced = ifNullOrWhiteSpace(result.mustBeReplaced, false);
  return result;
};

export const getJarvisCustomLocale = ({
  moduleCodeStrings,
  config,
  systemMessageCodeStrings,
  withSeparateModuleCodeString,
  langKey,
}) => {
  langKey = ifNullOrWhiteSpace(langKey, getLanguage().LangKey);
  let result = {};
  if (isNullOrWhiteSpace(moduleCodeStrings) === false) {
    let pageElem = {};
    _.split(moduleCodeStrings, ",").forEach((moduleCodeString) => {
      const jsonDataPageElem = require(`JarvisCustom/JarvisLocale/${langKey}/PageElement/${moduleCodeString}.json`);
      if (withSeparateModuleCodeString === true)
        pageElem = _.merge(pageElem, { [moduleCodeString]: jsonDataPageElem });
      else pageElem = _.merge(pageElem, jsonDataPageElem);
    });
    result.PE = pageElem;
  }

  if (isNullOrWhiteSpace(systemMessageCodeStrings) === false) {
    const jsonDataSystemMessage = require(`JarvisCustom/JarvisLocale/${langKey}/SystemMessage.json`);
    result.SM = _.pick(
      jsonDataSystemMessage,
      _.split(systemMessageCodeStrings, ",")
    );
  }

  if (isNullOrWhiteSpace(config) === false && _.isArray(config)) {
    const jsonDataConfig = require(`JarvisCustom/JarvisLocale/${langKey}/Config.json`);
    result.Config = _.pick(
      jsonDataConfig,
      config.map((conf) => {
        return conf.ConfigCode;
      })
    );
  }
  return result;
};
